import { createSlice } from "@reduxjs/toolkit";

export const graphSlice = createSlice({
  name: "graph",
  initialState: {
    analysisList: [],
    graphModelList: [],

    columnsUsers: {},
    outcomeColumns: {},
    relevanceColumns: {
      relevance_columns_count_list: [],
    },
  },
  reducers: {
    setGraphAnalysisList: (state, action) => {
      state.analysisList = action.payload;
    },
    setGraphGraphModelList: (state, action) => {
      state.graphModelList = action.payload;
    },

    setGraphColumnsUsers: (state, action) => {
      state.columnsUsers = action.payload;
    },
    setGraphOutcomeColumns: (state, action) => {
      state.outcomeColumns = action.payload;
    },
    setGraphRelevanceColumns: (state, action) => {
      state.relevanceColumns = action.payload;
    },
  },
});

export const {
  setGraphAnalysisList,
  setGraphGraphModelList,
  setGraphColumnsUsers,
  setGraphOutcomeColumns,
  setGraphRelevanceColumns,
} = graphSlice.actions;

export const selectGraphAnalysisList = (state) => state.graph.analysisList;
export const selectGraphGraphModelList = (state) => state.graph.graphModelList;

export const selectGraphColumnsUsers = (state) => state.graph.columnsUsers;
export const selectGraphOutcomeColumns = (state) => state.graph.outcomeColumns;
export const selectGraphRelevanceColumns = (state) =>
  state.graph.relevanceColumns;

export default graphSlice.reducer;
